/**
 * The chart's display modes, and the union derived from them.
 *
 * The array is the single source of truth: `ActivityChartMode` is read off it, so a mode cannot be
 * spelled without a picker entry, and adding an entry breaks the exhaustive switches in
 * `InvocationActivityChart` until it is handled. It lives outside the component file because
 * `react-refresh/only-export-components` does not recognize `as const satisfies` as a constant export.
 */
export const ACTIVITY_CHART_MODES = [
  { value: "rollup", label: "Waiting & running" },
  { value: "inflight", label: "By stage" },
  { value: "outcomes", label: "Outcomes" },
  { value: "credits", label: "Processing units" },
] as const satisfies ReadonlyArray<{ value: string; label: string }>;

export type ActivityChartMode = (typeof ACTIVITY_CHART_MODES)[number]["value"];
